import script from "./CrmPlan2dResults.vue?vue&type=script&setup=true&lang=js"
export * from "./CrmPlan2dResults.vue?vue&type=script&setup=true&lang=js"

import "./CrmPlan2dResults.vue?vue&type=style&index=0&id=40fadb16&lang=css"

const __exports__ = script;

export default __exports__